<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">
        Corporate Sales - Testimonial
      </h5>
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input
                v-model="filter"
                placeholder="Search"
              ></b-form-input>
              <b-input-group-append>
                <b-button
                  variant="primary"
                  :disabled="!filter"
                  @click="filter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col md="6" class="my-1" align="right">
          <!-- <b-dropdown
            :disabled="selected.length === 0"
            :variant="selected.length === 0 ? 'primary':'warning'"
            id="dropdown-1"
            text="Action"
            class="m-md-2"
          >
            <b-dropdown-item @click="submitStatus('publish')" href="#">Publish</b-dropdown-item>
            <b-dropdown-item @click="submitStatus('archive')" href="#">Archive</b-dropdown-item>
          </b-dropdown> -->
          <router-link :to="{ name: 'createCorpSalesTestimonial' }">
            <b-button variant="primary">
              <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>
          We're sorry, we're not able to retrieve this information at the
          moment, please try back later
        </p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        responsive
        show-empty
        ref="selectableTable"
        :select-mode="selectMode"
        @row-selected="onRowSelected"
        empty-text="no data"
        hover
        striped
        :items="getInfo"
        :fields="key"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        filter-debounce="500"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(content.id)="row">
          <div v-html="row.value.substring(0, 50)"></div>
        </template>
        <template v-slot:cell(image_jpg)="row">
          <b-img :src="row.value" width="75px" rounded alt="Image"></b-img>
        </template>
        <template v-slot:cell(created_at)="{ value, item }">
          <p class="mb-0">{{ item.created_at_date_only }}</p>
          by
          <label class="font-weight-bold">{{ item.created_by_username }}</label>
        </template>
        <template v-slot:cell(description.id)="row">
          <div v-html="row.value.substring(0, 50)"></div>
        </template>
        <template v-slot:cell(status)="row">
          <p class="text-success" v-if="row.value == 'publish'">Publish</p>
          <p class="text-warning" v-else-if="row.value == 'archive'">Archive</p>
        </template>
        <template v-slot:cell(updated_at)="{ value, item }">
          <div v-if="item.updated_at_date_only == ''">-</div>
          <div v-else>
            <p class="mb-0">{{ item.updated_at_date_only }}</p>
            by
            <label class="font-weight-bold">{{
              item.updated_by_username
            }}</label>
          </div>
        </template>
        <template v-slot:cell(action)="{ value, item }">
          <router-link
            :to="{
              name: 'editCorpSalesTestimonial',
              params: { id: item.id },
            }"
            class="text-dark"
            v-b-tooltip.hover
            title="Edit"
          >
            <img src="@/assets/ic-edit.svg" class="mr-2" alt />
          </router-link>
          <b-link
            v-b-tooltip.hover
            title="Delete"
            class="text-dark"
            @click="del(item.id)"
          >
            <img class="mr-2" src="@/assets/rectangle.svg" alt />
          </b-link>
          <b-link
            :class="{ 'order-link': item.order_field === 1 }"
            @click="orderOurCorpSales({ id: item.id, change: 'up' })"
            class="text-primary"
            v-b-tooltip.hover
            title="Up Order"
          >
            <i class="fas fa-arrow-up mr-2"></i>
          </b-link>
          <b-link
            class="text-primary"
            :class="{ 'order-link': item.is_last_order === true }"
            @click="orderOurCorpSales({ id: item.id, change: 'down' })"
            v-b-tooltip.hover
            title="Down Order"
          >
            <i class="fas fa-arrow-down"></i>
          </b-link>
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{ totalRows }}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      errored: false,
      items: [],
      selected: [],
      vuex: [],
      key: [
        {
          key: "created_at",
          label: "Created",
          sortable: true,
          class: "text-left w-10",
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
          class: "text-center",
        },
        {
          key: "title",
          label: "Title",
          sortable: true,
          class: "text-center",
        },
        {
          key: "description.id",
          label: "Testimonial",
          sortable: true,
          class: "text-center",
        },
        {
          key: "image_jpg",
          label: "Image",
          class: "text-center",
        },
        {
          key: "status",
          label: "Status",
          class: "text-center",
        },
        {
          key: "updated_at",
          label: "Updated",
          sortable: true,
          class: "text-left w-10",
        },
        { key: "action", label: "Action", class: "text-center w-10" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: "",
      sortDesc: true,
      sortDirection: "asc",
      filter: "",
      selected_field_true: true,
      selected_field_false: false,
      customerShow: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  methods: {
    onRowSelected(items) {
      this.selected = items;
    },
    toggleAll(checked) {
      this.selected = checked
        ? this.$refs.selectableTable.selectAllRows()
        : this.$refs.selectableTable.clearSelected();
    },
    submitStatus(status) {
      this.$swal({
        title: "Are you sure?",
        text: `You will ${status} this On Corporate Sales Testimonial!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, change it!",
      }).then((result) => {
        if (result.value) {
          const formData = new FormData();
          $.each(this.selected, (key, value) => {
            formData.append("partnership_testimonial_id", value.id);
            formData.append("status", status);
          });
          $.each(
            formData.getAll("partnership_testimonial_id"),
            (key, value) => {
              console.log(value);
            }
          );

          this.loading = true;

          this.$store
            .dispatch(
              "CorpSalesTestimonialModule/updateStatusCorpSalesTestimonial",
              formData
            )
            .then((response) => {
              this.loading = false;
              this.$refs.selectableTable.refresh();
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1000,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.serverError = error.response;
              console.log(error);
            });
        }
      });

      // console.log(list);
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      formData.append("status", "publish");
      formData.append("status", "archive");
      this.$store
        .dispatch(
          "CorpSalesTestimonialModule/getCorpSalesTestimonials",
          formData
        )
        .then((response) => {
          vm.totalRows = response.data.data.total_record;
          callback(response.data.data.results || []);
          this.loading = false;
        })
        .catch((error) => {
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    orderOurCorpSales(order) {
      this.loading = true;
      const orderData = {
        change_type: order.change,
      };
      this.$store
        .dispatch("CorpSalesTestimonialModule/orderCorpSalesTestimonial", {
          id: order.id,
          orderData,
        })
        .then((response) => {
          this.$refs.selectableTable.refresh();
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(response);
        })
        .catch((error) => {
          this.loading = false;
          this.serverError = error.response.data;
          console.log(error);
        });
    },
    del(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(
            "CorpSalesTestimonialModule/delCorpSalesTestimonial",
            id
          );
          this.$refs.selectableTable.refresh();
          this.$swal("Deleted!", "Your file has been deleted.", "success");
        }
      });
    },
  },
  watch: {
    selected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newVal.length === this.items.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
  },
};
</script>

<style scoped>
u {
  text-decoration: underline;
}
.pointer-off {
  pointer-events: none;
}
.title {
  width: 120px;
}
</style>
